export default __webpack_public_path__ + "static/media/Milkbun-loading.11f805b0.png";